module.exports = __webpack_public_path__ + "media/assets/img/products/studio_auto-not-selected-eda972ab2b839db5547d12a99f0d6558.svg";